import React, { PureComponent } from 'react';
import { get } from 'lodash';
import FoodProfileBadge from 'apps/foodProfile/containers/FoodProfileBadge';
import { SUITABILITY_EMPTY } from 'apps/foodProfile/consts';

function generateIngridientFlags(suitability) {
  const {
    containIngredients,
    mayContainIngredients,
  } = suitability;
  const titleParts = [];
  if (containIngredients.length) titleParts.push(`Contains ${containIngredients.join(', ')}.`);
  if (mayContainIngredients.length) titleParts.push(`May contain ${mayContainIngredients.join(', ')}.`);

  return titleParts.join(' ');
}

export default class FoodProfileAlert extends PureComponent {
  render() {
    const {
      isBadgeEnabled,
      suitability = SUITABILITY_EMPTY,
      profile,
      barcode,
      showFoodProfilePopup,
    } = this.props;

    const profileConditions = get(profile, ['0', 'Conditions'], []);
    const conditionsSelected = profileConditions
      .filter(condition => condition.ConditionSelected)
      .map(condition => condition.ConditionName);
    const ingredientFlags = generateIngridientFlags(suitability);

    if (!isBadgeEnabled || suitability.isSuitable !== 0) return null;

    return (
      <div className="bop-foodProfileAlert">
        <div className="bop-foodProfileAlert__header">
          Food Profile alert <button onClick={() => showFoodProfilePopup(5)}>(Edit)</button>
        </div>
        <div className="gn-content bop-info__field">
          <h6>Food allergies and intolerances selected:</h6>
          <div className="bop-info__content">{conditionsSelected.join(', ')}</div>
        </div>
        <div className="gn-content bop-info__field">
          <h6>Ingredient flags:</h6>
          <div className="bop-info__content">{ingredientFlags}</div>
        </div>
        <FoodProfileBadge barcode={barcode} />
      </div>
    );
  }
}
